import type { StyleRule } from '@archipro-design/aria';
import {
    HeaderClassName,
    pxArrayToRem,
    pxToRem,
    SubheaderClassName,
} from '@archipro-design/aria';

export const Container: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([30, 18, 0]),
    marginBottom: pxToRem(30),
    [`& .${HeaderClassName}`]: {
        textTransform: 'uppercase',
        marginBottom: pxToRem(29),
    },
    [theme.screen.tablet]: {
        padding: '0',
        marginBottom: theme.siteVariables.spaces['space-24'],
        [`& .${HeaderClassName}`]: {
            marginTop: pxToRem(200),
            marginLeft: pxToRem(924),
            marginBottom: pxToRem(74),
            fontSize: pxToRem(22),
            textTransform: 'uppercase',
            lineHeight: theme.siteVariables.letterSpacingMedium,
        },
    },
});

export const Grid: StyleRule = ({ theme }) => ({
    [theme.screen.laptop]: {
        borderTop: `2px solid ${theme.siteVariables.colors.grey[125]}`,
        paddingTop: '0',
        columnGap: '0',
        [`& > .${SubheaderClassName}`]: {
            padding: pxArrayToRem([18, 0]),
            letterSpacing: theme.siteVariables.letterSpacingNormal,
            fontSize: pxToRem(16),
            lineHeight: theme.siteVariables.lineHeightDefault,
            borderBottom: `2px solid ${theme.siteVariables.colors.grey[125]}`,
            minHeight: pxToRem(56),
        },
    },
});

export const GridMobile: StyleRule = {
    rowGap: pxToRem(7),
};

export const LeftAlignedCaption: StyleRule = {
    textAlign: 'left',
};

export const RightAlignedCaption: StyleRule = {
    textAlign: 'right',
};

export const AwardName: StyleRule = ({ theme }) => ({
    ...theme.siteVariables.textStyles.Text.Medium65,
});

export const Divider: StyleRule = ({ theme }) => ({
    borderTop: `1px solid ${theme.siteVariables.colors.grey['125']}`,
    borderBottom: '0 none',
    width: '100%',
    marginTop: pxToRem(4),
    marginBottom: pxToRem(5),
});

export const ViewMoreContainer: StyleRule = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: pxToRem(40),
};
